export const wrapperStyles = {
  justifyItems: "center",
  py: [6, 6, 6, 7, 8]
};
